import App from 'next/app';
import React from 'react';
import NowPlayingClient from 'nowplaying-client-2';
import { AudioPlayerProvider } from 'context/AudioPlayerContext';
import Layout from '../layouts/Layout';
import Script from 'next/script';
import { SessionProvider } from 'next-auth/react';
import { FavoritesContextProvider } from 'context/FavoritesContext';
import 'regenerator-runtime/runtime';
import { PotlatchNotificationProvider } from '../context/PotlatchNotificationContext';
import { AdCategoriesContextProvider } from 'context/AdCategoriesContext';
import {
  findPrimaryCollectionSlug,
  findCollectionsSlugs,
} from '../utils/findPrimaryCategory';

class MPRNews extends App {
  constructor(props) {
    super(props);
  }

  loadPlayer = () => {
    return null;
  };

  setNowPlayingTitle(schedule) {
    let title = schedule[0].shows[0].name;
    if (schedule[0].people[0]) {
      title += ` with ${schedule[0].people[0].name}`;
    }
    return title;
  }

  setNowPlayingThumbnail(songdata) {
    let thumbnail = songdata.art_url;
    if (songdata.art_url) {
      thumbnail += ` with ${songdata.art_url}`;
    }
    return thumbnail;
  }

  setupNowPlaying = () => {
    const self = this;
    const client = new NowPlayingClient({
      server: 'wss://nowplayingv2.publicradio.org',
    });
    const registrations = [];
    const service = 'mpr-news';

    // Register the callback for a playlist change.
    const schedule_registration = client.register_callback(
      service,
      'schedule',
      function (data) {
        if (self.state.isAudioLive) {
          self.setState(
            {
              nowPlayingTitle: self.setNowPlayingTitle(data.schedule),
            },
            () => {
              self.setState({ audioTitle: self.state.nowPlayingTitle });
            }
          );
        }
      }
    );
    // Add the registration object to the array of registrations.
    registrations.push(schedule_registration);
  };

  render() {
    const { Component, pageProps } = this.props;

    const slug = findPrimaryCollectionSlug(pageProps);
    const collections = findCollectionsSlugs(pageProps);

    return (
      <>
        <Script strategy="beforeInteractive">
          {`
          window.dataLayer = window.dataLayer || [];
          if("${pageProps?.session?.user?.id}" != 'undefined') {
            dataLayer.push({ event: 'sessionView', user_id: "${pageProps?.session?.user?.id}"})
          }
            `}
        </Script>

        <Script
          strategy="beforeInteractive"
          src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
        />
        <link rel="preconnect" href="https://dev.visualwebsiteoptimizer.com" />
        <Script id="vwoCode" strategy="beforeInteractive">
          {`
        window._vwo_code || (function() {
        var account_id=940895,
        version=2.1,
        settings_tolerance=2000,
        hide_element='body',
        hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important;',
        /* DO NOT EDIT BELOW THIS LINE */
        f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={nonce:v&&v.nonce,use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){if(performance.getEntriesByName('first-contentful-paint')[0]){return''}return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById('_vis_opt_path_hides');if(t)t.parentNode.removeChild(t);if(e)(new Image).src='https://dev.visualwebsiteoptimizer.com/ee.gif?a='+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement('script');t.type='text/javascript';if(e.src){t.src=e.src}else{t.text=e.text}v&&t.setAttribute('nonce',v.nonce);d.getElementsByTagName('head')[0].appendChild(t)},load:function(e,t){var n=this.getSettings(),i=d.createElement('script'),r=this;t=t||{};if(n){i.textContent=n;d.getElementsByTagName('head')[0].appendChild(i);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open('GET',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||'text';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200||o.status===304){w._vwo_code.addScript({text:o.responseText})}else{w._vwo_code.finish('&e=loading_failure:'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}w._vwo_code.finish('&e=loading_failure:'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){w._vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!=='body'){t=d.createElement('style');var n=this.hide_element(),i=n?n+this.hide_element_style():'',r=d.getElementsByTagName('head')[0];t.setAttribute('id','_vis_opt_path_hides');v&&t.setAttribute('nonce',v.nonce);t.setAttribute('type','text/css');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));r.appendChild(t)}else{t=d.getElementsByTagName('head')[0];var i=d.createElement('div');i.style.cssText='z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;';i.setAttribute('id','_vis_opt_path_hides');i.classList.add('_vis_hide_layer');t.parentNode.insertBefore(i,t.nextSibling)}var o=window._vis_opt_url||d.URL,s='https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(o)+'&vn='+version;if(w.location.search.indexOf('_vwo_xhr')!==-1){this.addScript({src:s})}else{this.load(s+'&x=true')}}};w._vwo_code=code;code.init();})();(function(){var i=window;function t(){if(i._vwo_code){var e=t.hidingStyle=document.getElementById('_vis_opt_path_hides')||t.hidingStyle;if(!i._vwo_code.finished()&&!_vwo_code.libExecuted&&(!i.VWO||!VWO.dNR)){if(!document.getElementById('_vis_opt_path_hides')){document.getElementsByTagName('head')[0].appendChild(e)}requestAnimationFrame(t)}}}t()})();
        `}
        </Script>

        <Script>
          {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-KTT2Z2');
          `}
        </Script>

        <Script strategy="lazyOnload">
          {`
(function(d, u, ac) {
	var s = d.createElement('script');
	s.type = 'text/javascript';
	s.src = 'https://a.omappapi.com/app/js/api.min.js';
	s.async = true;
	s.dataset.user = u;
	s.dataset.account = ac;
	d.getElementsByTagName('head')[0].appendChild(s);
})(document, 108635, 120426);
`}
        </Script>
        <SessionProvider session={pageProps?.session}>
          <AudioPlayerProvider>
            <FavoritesContextProvider>
              <PotlatchNotificationProvider>
                <AdCategoriesContextProvider
                  primaryCategory={slug}
                  adCategories={collections}
                >
                  <Layout
                    appStyleLayout={pageProps?.appStyleLayout || false}
                    layout={pageProps?.layout || 'home'}
                    resourceType={
                      pageProps?.resourceType ? pageProps?.resourceType : 'page'
                    }
                  >
                    <Component {...pageProps} />
                  </Layout>
                </AdCategoriesContextProvider>
              </PotlatchNotificationProvider>
            </FavoritesContextProvider>
          </AudioPlayerProvider>
        </SessionProvider>
      </>
    );
  }
}

export default MPRNews;
